import React from 'react';
import { Link } from 'react-router-dom';

import { ButtonWrapper, Container, ErrorText } from './ConsentHTML.styled';
import Button from 'components/Buttons/NewButton';
import { utils } from 'kb-shared';

import { ConsentHTMLErrorProps } from './ConsentHTMLError.types';

const { KBContacts } = utils;

export const ConsentHTMLError = ({ text, link }: ConsentHTMLErrorProps) => {
  return (
    <Container>
      <ErrorText>
        Sorry, we&apos;re unable to load this form.
        <br />
        Please try again, or contact us at{' '}
        <a className="link" href={`mailto:${KBContacts.navigatorEmail}`}>
          {KBContacts.navigatorEmail}
        </a>
        .
      </ErrorText>
      {text && link && (
        <Link to={link}>
          <ButtonWrapper>
            <Button text={text} />
          </ButtonWrapper>
        </Link>
      )}
    </Container>
  );
};

export default ConsentHTMLError;
